import {SET_YEAR_NOTIFICATION_BUBBLE} from "../../../../../enums/Employees/employees.types";

export const getPendingRequestsInfoAction = ({status, direction}) => {
    return {
        type: SET_YEAR_NOTIFICATION_BUBBLE,
        payload: {status, direction},
    };
};